<style>
    table, th, td{
         border: solid 1px rgba(40,40,40,0.2);
         font-size:14px;
         padding:5px;
     }
     table{
         width: 100%;
     }
 </style>
<div class="row">
    <div class="col-12">
        <h2>Fundas Aluminizadas</h2>
    </div>
    <div class="col-12">
        <table id="myTable">
            <tr class="header">
              <th style="width:10%;"><t1>Código</t1></th>
              <th style="width:30%;"><t1>Descripcion</t1></th>
              <th style="width:20%;"><t1>Espesor</t1></th>
              <th style="width:30%;"><t1>Conductividad Térmica</t1></th>
            </tr>
            <tr>
              <td><t2>FA001</t2></td>
              <td><t2>Hechas de Polietileno expandido con un foil aluminizado que refleja el 96% de la transmisión de calor por radiación</t2></td>
              <td><t2>5.00 mm</t2></td>
              <td><t2> 0.045 W/M'C </t2></td>
            </tr>
          </table>
    </div>
</div>